import groupBy from 'lodash/groupBy';

class CheckinInvoice {
  id: number;
  number: number;

  constructor(fields) {
    Object.assign(this, fields);
  }
}
export function createCheckinInvoice(blob: any): CheckinInvoice {
  return new CheckinInvoice({
    id: blob.invoice_id,
    number: blob.invoice_number,
  });
}


class CheckinForm {
  id: number;
  name: string;
  isRead: boolean;
  isSubmit: boolean;

  constructor(fields) {
    Object.assign(this, fields);
  }
}

function createCheckinForm(blob) {
  return new CheckinForm({
    id: blob.id,
    name: blob.name,
    isRead: !!blob.is_read,
    isSubmit: !!blob.is_submit,
  });
}

class CheckinReward {
  id: number;
  text: string;
  amount: number;

  constructor(fields) {
    Object.assign(this, fields);
  }
}

function createCheckinReward(blob) {
  return new CheckinReward({
    id: blob.reward_id,
    text: blob.reward_text,
    amount: blob.reward_amount,
  });
}


class CheckinJob {
  id: number;
  status: string;
  serviceId: string;
  serviceName: string;

  constructor(fields) {
    Object.assign(this, fields);
  }
}

export function createJobList(blobs: any): CheckinJob[] {
  return blobs.map(job => {
    const jobService = (job.services || [])[0];
    return {
      id: job.job_id,
      status: job.job_status,
      serviceId: jobService.id,
      serviceName: jobService.name,
    } as CheckinJob;
  }) as CheckinJob[] ;
}


export class StylistJob {
  stylistId: number;
  stylistName: string;
  jobs: CheckinJob[];

  constructor(fields) {
    Object.assign(this, fields);
  }
}

export function createStylistJobs(blobs: any): StylistJob[] {
  const jobGroups = groupBy(blobs, (blob) => (blob.stylist_id));
  const jobGroupKeys = Object.keys(jobGroups);

  if (jobGroupKeys.length === 1) {
    const stylistBlob = blobs[0];

    return [{
      stylistId: stylistBlob.stylist_id,
      stylistName: stylistBlob.stylist_name,
      jobs: createJobList(blobs || []),
    }] as StylistJob[];
  }

  return jobGroupKeys.map(groupKey => {
    const stylistBlob = jobGroups[groupKey][0];

    return {
      stylistId: stylistBlob.stylist_id,
      stylistName: stylistBlob.stylist_name,
      jobs: createJobList(jobGroups[groupKey] || []),
    } as StylistJob;
  }) as StylistJob[];
}


export class CheckinData {
  id: number;
  type: string;
  clientName: string;
  createdDate: string;
  invoice: CheckinInvoice;
  stylistJobs: StylistJob[];
  formData: CheckinForm[];
  rewardData: CheckinReward[];

  constructor(fields) {
    Object.assign(this, fields);
  }
}

export function createCheckinData(blob: any): CheckinData {
  return new CheckinData({
    id: blob.cid,
    type: blob.check_in_type,
    clientName: blob.customer_name,
    createdDate: blob.create_date,
    rewardData: (blob.reward_data || []).map(createCheckinReward),
    formData: (blob.form_data || []).map(createCheckinForm),
    invoice: createCheckinInvoice(blob.invoice_data),
    stylistJobs: createStylistJobs(blob.stylist_jobs || []),
  });
}
